// SavvytronHeader.jsx
import React, { forwardRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiX } from "react-icons/fi";

const SavvytronHeader = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNav = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const isActive = (path) => location.pathname === path;


  function GoldHamburger({ open }) {
  return (
    <div className="flex flex-col gap-[6px] transition-all">
      <span
        className={`
          w-7 h-[3px] rounded-full transition-all
          ${open ? "rotate-45 translate-y-[8px]" : ""}
          bg-gradient-to-r from-[#c59d37] to-[#785f14]
        `}
      ></span>

      <span
        className={`
          w-7 h-[3px] rounded-full transition-all
          ${open ? "opacity-0" : ""}
          bg-gradient-to-r from-[#c59d37] to-[#785f14]
        `}
      ></span>

      <span
        className={`
          w-7 h-[3px] rounded-full transition-all
          ${open ? "-rotate-45 -translate-y-[8px]" : ""}
          bg-gradient-to-r from-[#c59d37] to-[#785f14]
        `}
      ></span>
    </div>
  );
}


  return (
    <>
      <div className="sticky top-0 z-50 backdrop-blur-md bg-white/95 shadow-sm border-b border-gray-200/60">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-3">

          {/* Logo */}
          <button
            type="button"
            onClick={() => handleNav("/")}
            className="flex items-center gap-2 sm:gap-3 hover:opacity-90 shine min-w-0"
          >
            <img
              ref={ref}
              src="/savvytron-logo.png"
              alt="SavvyTron logo"
              className="w-10 h-10 sm:w-14 sm:h-14 flex-shrink-0"
            />
            <p className="text-brand font-copperplate text-xl sm:text-3xl md:text-5xl truncate">
              SavvyTron
            </p>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8 items-center font-copperplate text-brand font-medium relative">

            <NavItem label="Home" path="/" isActive={isActive} handleNav={handleNav} />
            <NavItem label="Services" path="/services" isActive={isActive} handleNav={handleNav} />
            <NavItem label="Contact" path="/contact" isActive={isActive} handleNav={handleNav} />

          </div>

          {/* Mobile Hamburger */}
          <button
            type="button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            className="md:hidden flex-shrink-0 p-2 -mr-2 relative z-50"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <GoldHamburger open={mobileOpen} />
          </button>

        </div>
      </div>

      {/* Mobile menu rendered outside sticky header so z-index isn't trapped */}
      {mobileOpen && (
        <div className="fixed inset-0 bg-white/95 backdrop-blur-xl z-[100] flex flex-col items-center justify-center space-y-8 text-xl font-medium text-brand md:hidden">
          <button
            type="button"
            aria-label="Close menu"
            className="absolute top-5 right-5 p-2 text-3xl text-[#785f14]"
            onClick={() => setMobileOpen(false)}
          >
            <FiX />
          </button>

          <MobileNavItem label="Home" path="/" isActive={isActive} handleNav={handleNav} />
          <MobileNavItem label="Services" path="/services" isActive={isActive} handleNav={handleNav} />
          <MobileNavItem label="Contact" path="/contact" isActive={isActive} handleNav={handleNav} />
        </div>
      )}
    </>
  );
});

/* ----------------------------
   Desktop Nav Item Component
----------------------------- */
function NavItem({ label, path, isActive, handleNav }) {
  return (
    <button
      onClick={() => handleNav(path)}
      className={`
        relative px-3 py-1 rounded-full transition
        ${isActive(path) ? "text-brand" : "hover:text-brand"}
      `}
    >
      {label}

      {/** GOLD Spotlight */}
      {isActive(path) && (
        <span className="absolute left-1/2 -bottom-[6px] -translate-x-1/2 w-10 h-2
          bg-gradient-to-r from-[#d4af37]/0 via-[#d4af37]/60 to-[#d4af37]/0
          blur-md rounded-full opacity-80"></span>
      )}

      {/** Pill behind text */}
      {isActive(path) && (
        <span className="absolute inset-0 bg-brand/10 rounded-full -z-10"></span>
      )}
    </button>
  );
}

/* ----------------------------
  Mobile Nav Item (Centered)
----------------------------- */
function MobileNavItem({ label, path, isActive, handleNav }) {
  return (
    <button
      onClick={() => handleNav(path)}
      className={`
        text-2xl font-copperplate relative px-4 py-2
        ${isActive(path) ? "text-brand font-semibold" : "text-gray-600"}
      `}
    >
      {label}

      {/** stronger spotlight in mobile */}
      {isActive(path) && (
        <span className="absolute left-1/2 top-full -translate-x-1/2 w-20 h-3
          bg-gradient-to-r from-[#d4af37]/0 via-[#d4af37]/70 to-[#d4af37]/0
          blur-lg rounded-full opacity-90"></span>
      )}
    </button>
  );
}

export default SavvytronHeader;
